var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHaba(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFF",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 2",
    viewBox: "0 0 64 64",
    transform: "matrix(.69 0 0 .69 15.5 15.5)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.87 5.19c4.79 3 7.71 8.91 7.71 16.39 0 10.27-4.26 19.13-8 25h1.3c5.24-5.72 11.4-14.64 11.4-25-.05-7.94-4.81-13.97-12.41-16.39zM29.36 46.58h5.28a86.93 86.93 0 0 0 3.78-25C38.42 9.5 35.09 4 32 4s-6.42 5.5-6.42 17.58a86.93 86.93 0 0 0 3.78 25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.45 21.58c0 10.34 4.45 19.26 8.25 25h2.59a87.49 87.49 0 0 1-3.74-25c0-8.32 1.67-14.6 4.38-17.24C22 5.86 17.45 12.48 17.45 21.58zM35.71 46.58h2.59c3.8-5.74 8.25-14.66 8.25-25 0-9.1-4.53-15.72-11.48-17.24 2.71 2.64 4.38 8.92 4.38 17.24a87.49 87.49 0 0 1-3.74 25z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.42 21.58c0-7.47 2.92-13.37 7.7-16.39-7.59 2.43-12.35 8.45-12.35 16.39 0 10.36 6.16 19.28 11.4 25h1.3c-3.79-5.87-8.05-14.73-8.05-25zM35 47.61H24.14c.9.94 1.81 1.84 2.73 2.69h10.26c.92-.85 1.83-1.75 2.73-2.69H35zM35.28 52.34h-6.56a2.11 2.11 0 0 0-2.06 2.47l.63 3.47A2.09 2.09 0 0 0 29.35 60h5.3a2.09 2.09 0 0 0 2.06-1.72l.63-3.47a2.11 2.11 0 0 0-2.06-2.47zm-.77 4.35h-5a.52.52 0 0 1 0-1h5a.52.52 0 0 1 0 1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaba);
export default __webpack_public_path__ + "static/media/HABA.8bfcda88ab2ecd0389c17e16fede75dc.svg";
export { ForwardRef as ReactComponent };